import {DataSubjectRights} from '@gaia/components/DataSubjectRights';
import {useMediaQuery} from '@gaia/hooks/useMediaQuery';
import {outsideDataSubjectRightsFormURL, outsidePrivacyPolicyURL, termsOfUseURL} from '@gaia/urls';

import classes from './Map.module.css';

// exposed by the cookie consent script
declare const showConsentPreferencesPopup: () => void;

export function MapFooter() {
    const doShrinkCopy = useMediaQuery('(max-width: 600px)');

    return (
        <ul className={classes.footer}>
            <li>
                <a href={outsidePrivacyPolicyURL} target='_blank' rel='noreferrer'>
                    Privacy
                </a>
            </li>
            <li>
                <a href={termsOfUseURL} target='_blank' rel='noreferrer'>
                    Terms
                </a>
            </li>
            <DataSubjectRights>
                <li>
                    <a href={outsideDataSubjectRightsFormURL} target='_blank' rel='noreferrer'>
                        {doShrinkCopy ? 'DSR' : 'Privacy Request'}
                    </a>
                </li>
            </DataSubjectRights>
            <li>
                {/* <button class="cmp-revoke-consent"> as specified by Securiti.ai documentation,
                 so the cookie consent script can find the element and attach a click event--which
                 currently does not work for dynamically-created DOM elements (i.e. React), so we
                 invoke the handler directly. */}
                <button
                    className='cmp-revoke-consent'
                    onClick={() => showConsentPreferencesPopup()}
                >
                    {doShrinkCopy ? 'Cookies' : 'Manage Cookie Preferences'}
                </button>
            </li>
        </ul>
    );
}
